import React, { useEffect } from "react";
import Nav from "./components/common/Nav";
import { Route, Routes, Navigate } from "react-router-dom";
import VideoManagementPage from "./components/video/VideoManagementPage";
import LoginPage from "./components/accounts/LoginPage";
import ProtectedRoute from "./components/common/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ManageMapMarkersController from "./components/mapMarkers/ManageMapMarkersPage";
import VideoCataloguesPage from "./components/videoCatalogues/VideoCataloguesPage";
import PageComingSoon from "./components/common/PageComingSoon";
import ManageCountriesController from "./components/countries/ManageCountriesPage";
import ManageIUCNStatusController from "./components/iucnStatus/ManageIUCNStatusPage";
import ManagePopulationTrendController from "./components/populationTrend/ManagePopulationTrendController";
import ManageSpeciesController from "./components/species/ManageSpeciesPage";
import ManageAddEditSpecies from "./components/species/ManageAddEditSpecies";
import ManageOrganizationsPage from "./components/organzations/ManageOrganizationsPage";
import ManageAddEditOrg from "./components/organzations/ManageAddEditOrg";
import ManageAddEditVideo from "./components/video/ManageAddEditVideo";
import ManageAddEditMapMarker from "./components/mapMarkers/ManageAddEditMapMarker";
import ManageAddEditCatalogue from "./components/videoCatalogues/ManageAddEditCatalogue";
import ManageUsersPage from "./components/users/ManageUsersPage";
import ManageAddEditUser from "./components/users/ManageAddEditUser";
import UnauthorizedResponse from "./helpers/UnauthorizedResponse";
import ManageInstallationsPage from "./components/installations/ManageInstallationsPage";
import ManageAddEditInstallation from "./components/installations/ManageAddEditInstallation";
import ManageDevicesPage from "./components/devices/ManageDevicesPage";
import ManageAddEditDevice from "./components/devices/ManageAddEditDevice";
import { getCurrentUser } from "./helpers/authHeader";
import { fetchWildXROrgId } from "./helpers/wildXROrgIdHelper";

function isUserLoggedIn() {
  return localStorage.getItem("userAuthorized") === "true";
}

//now rendering the pages rather than the multistep form
function App() {
  useEffect(() => {
    fetchWildXROrgId();
  }, []);

  return (
    <div className="bg-grayScale-100">
      <Nav />
      <div className="">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/unauthorized" element={<UnauthorizedResponse />} />
          {isUserLoggedIn() ? (
            <>
              <Route
                path="/video/add"
                element={
                  <ProtectedRoute>
                    <ManageAddEditVideo existingVideo={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/video/:id/edit"
                element={
                  <ProtectedRoute>
                    <ManageAddEditVideo existingVideo={true} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mapMarker/add"
                element={
                  <ProtectedRoute>
                    <ManageAddEditMapMarker existingMapMarker={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mapMarker/:id/edit"
                element={
                  <ProtectedRoute>
                    <ManageAddEditMapMarker existingMapMarker={true} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/videoCatalogue/add"
                element={
                  <ProtectedRoute>
                    <ManageAddEditCatalogue existingCatalogue={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/videoCatalogue/:id/edit"
                element={
                  <ProtectedRoute>
                    <ManageAddEditCatalogue existingCatalogue={true} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="video/:id/uploadVideo"
                element={
                  <ProtectedRoute>
                    <ManageAddEditVideo
                      uploadVideoPage={true}
                      existingVideo={true}
                    />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/mapMarkers"
                element={
                  <ProtectedRoute>
                    <ManageMapMarkersController selectMapMarkersPage={false} />
                  </ProtectedRoute>
                }
              />
              {/* <Route
                  path="/video/:id/details"
                  element={
                    <ProtectedRoute>
                      <MultiStepForm
                        steps={videoEditSteps}
                        header={"Edit Video"}
                        goBackString=""
                      />
                    </ProtectedRoute>
                  }
                /> */}
              <Route
                path="/countries"
                element={
                  <ProtectedRoute>
                    <ManageCountriesController />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/iucnStatus"
                element={
                  <ProtectedRoute>
                    <ManageIUCNStatusController />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/populationTrend"
                element={
                  <ProtectedRoute>
                    <ManagePopulationTrendController />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/species/add"
                element={
                  <ProtectedRoute>
                    <ManageAddEditSpecies existingSpecies={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/species/:id/edit"
                element={
                  <ProtectedRoute>
                    <ManageAddEditSpecies existingSpecies={true} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/species"
                element={
                  <ProtectedRoute>
                    <ManageSpeciesController />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/organization/add"
                element={
                  <ProtectedRoute>
                    <ManageAddEditOrg existingOrg={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/organization/:id/edit"
                element={
                  <ProtectedRoute>
                    <ManageAddEditOrg existingOrg={true} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/organizations"
                element={
                  <ProtectedRoute>
                    <ManageOrganizationsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <VideoManagementPage selectVideosPage={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/videoCatalogues"
                element={
                  <ProtectedRoute>
                    <VideoCataloguesPage selectVideoCataloguesPage={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <ProtectedRoute>
                    <ManageUsersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user/:id/edit"
                element={
                  <ProtectedRoute>
                    <ManageAddEditUser existingUser={true} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/user/add"
                element={
                  <ProtectedRoute>
                    <ManageAddEditUser existingUser={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/installations"
                element={
                  <ProtectedRoute>
                    <ManageInstallationsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/installation/:id/edit"
                element={
                  <ProtectedRoute>
                    <ManageAddEditInstallation existingInstallation={true} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/installation/add"
                element={
                  <ProtectedRoute>
                    <ManageAddEditInstallation existingInstallation={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/devices"
                element={
                  <ProtectedRoute>
                    <ManageDevicesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/device/:id/edit"
                element={
                  <ProtectedRoute>
                    <ManageAddEditDevice existingDevice={true} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/device/add"
                element={
                  <ProtectedRoute>
                    <ManageAddEditDevice existingDevice={false} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/developmentNotice"
                element={
                  <ProtectedRoute>
                    <PageComingSoon />
                  </ProtectedRoute>
                }
              />
              {/* Other routes */}
            </>
          ) : (
            <Route path="*" element={<Navigate to="/login" />} />
          )}
        </Routes>
        <ToastContainer />
      </div>
    </div>
  );
}

export default App;
